import { withPagination } from 'shared/table/hoc/withPagination';
import { TransfersTable } from '../TransfersTable/TransfersTable';

import { useFileDownloader } from 'shared/hooks/useFileDownloader';
import { useCoreService } from 'core/services/useCoreService';
import { SearchTransfersRequest } from '../../../models/SearchTransfersRequest';
import { Transferencia } from '../../models/Transferencia';
import { Pageable } from '../../../../shared/table/models/Pageable';

const TableWithPagination = withPagination<Transferencia>(TransfersTable);

export const TransfersTableWithPagination = (props: {
  searchParams: SearchTransfersRequest;
  transferencias?: Pageable<Transferencia>;
  loadingState: boolean;
}) => {
  const coreService = useCoreService();
  const { downloadFile } = useFileDownloader();

  const onDownloadComprobante = async (transfer: Transferencia) => {
    const filePayload =
      await coreService.downloadTransferComprobante(transfer.id);

    downloadFile(filePayload, filePayload.name);
  };

  const onChangePaginationStatus = async (status: {
    pageNumber: number;
    pageSize: number;
  }): Promise<Pageable<Transferencia>> => {
    props.searchParams.page = status.pageNumber;
    props.searchParams.size = status.pageSize;
    return coreService.findTransferencias(props.searchParams);
  };

  return (
    <TableWithPagination
      pageableInit={props.transferencias}
      loadingState={props.loadingState}
      dataFetcherFunction={onChangePaginationStatus}
      onDownloadComprobante={onDownloadComprobante}
      noResultsMessages="No se encontraron transferencias que concuerden con los parámetros de la búsqueda"
    />
  );
};